import axiosInstance from 'services/axiosMiddleware';

export async function resendEmailOtp(email) {
  console.log(email);
  try {
    const response = await axiosInstance.post('auth/resendemailotp', email);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
